import React from "react";

export const Hover: React.FunctionComponent<{onHover:any,children:any}> = ({ onHover, children }) => (
  <div className="hover">
    <div className="__no-hover">{children}</div>
    <div className="__hover">{onHover}</div>
  </div>
)
